export default __webpack_public_path__ + "static/media/carole.7523d28a.jpg";